export function menu() {
  const navbarMenu = document.getElementById("navbar");
  const burgerMenu = document.querySelector(".header__burger");
  const overlayMenu = document.querySelector(".overlay");

  // Show and Hide Navbar Function
  const toggleMenu = () => { 
    navbarMenu.classList.toggle("header__navbar--active");
    overlayMenu.classList.toggle("overlay--active");
  };

  // Collapsible Mobile Submenu Function
  const collapseSubMenu = () => {
    navbarMenu
      .querySelector(".menu-dropdown--active .submenu")
      .removeAttribute("style");
    navbarMenu
      .querySelector(".menu-dropdown--active")
      .classList.remove("menu-dropdown--active");
  };

  // Toggle Mobile Submenu Function
  const toggleSubMenu = (e) => {
    if (e.target.hasAttribute("data-toggle") && window.innerWidth <= 992) {
      e.preventDefault();
      const menuDropdown = e.target.parentElement;

      // If Dropdown is Expanded, then Collapse It
      if (menuDropdown.classList.contains("menu-dropdown--active")) {
        collapseSubMenu();
      } else {
        // Collapse Existing Expanded Dropdown
        if (navbarMenu.querySelector(".menu-dropdown--active")) {
          collapseSubMenu();
        }

        // Expanded the New Dropdown
        menuDropdown.classList.add("menu-dropdown--active");
        const subMenu = menuDropdown.querySelector(".submenu");
        subMenu.style.maxHeight = subMenu.scrollHeight + "px";
      }
    }
  };

  // Fixed Resize Window Function
  const resizeWindow = () => {
    if (window.innerWidth > 992) {
      if (navbarMenu.classList.contains("header__navbar--active")) {
        toggleMenu();
      }
      if (navbarMenu.querySelector(".menu-dropdown--active")) {
        collapseSubMenu();
      }
    }
  };

  // Initialize Event Listeners
  burgerMenu.addEventListener("click", toggleMenu);
  overlayMenu.addEventListener("click", toggleMenu);
  navbarMenu.addEventListener("click", toggleSubMenu);
  window.addEventListener("resize", resizeWindow);
}
